<template lang="html">
  <component :is="tag" class="text__hint" :class="{ bold: bold }">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'bimTextHint',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__hint {
  font-size: 10px;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.text__hint.bold {
  font-weight: bold;
}
</style>
